<template>
  <div class="global-container">
    <div class="left-container">
      <img class="phone-img" :src="imgPhone" alt="Prévisualisation téléphone" />
    </div>
    <div class="right-container">
      <div class="container">
        <div class="text">
          <h2>{{ $t('home.modale.mobileapp.title') }}</h2>
          <h3>{{ $t('home.modale.mobileapp.text') }}</h3>
        </div>
      </div>
      <div class="img-container">
        <div class="store">
          <img class="qrcode" :src="qrCodeAndroid" alt="QR code android" />
          <img @click="playStoreLink" class="links" :src="linkStoreAndroid" alt="Google Play" />
        </div>
        <div class="store">
          <img class="qrcode" :src="qrCodeApple" alt="QR code apple" />
          <img @click="appleStoreLink" class="links" :src="linkStoreApple" alt="Apple Store" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'PortailMobile',
  methods: {
    playStoreLink() {
      window.open('https://play.google.com/store/apps/details?id=com.gh.mobile.portail.extranet');
    },
    appleStoreLink() {
      window.open('https://apps.apple.com/fr/app/portail-partenaire/id1608033059');
    },
  },
  computed: {
    closeIcon() {
      return require('@/assets/img/close-black.svg');
    },
    imgPhone() {
      return require('@/assets/img/mobileAppModale/phoneImg.png');
    },
    qrCodeAndroid() {
      return require('@/assets/img/mobileAppModale/QRCodeAndroid.png');
    },
    linkStoreAndroid() {
      return require('@/assets/img/mobileAppModale/googleplay.fr_ALL.png');
    },
    qrCodeApple() {
      return require('@/assets/img/mobileAppModale/QRCodeApple.png');
    },
    linkStoreApple() {
      return require('@/assets/img/mobileAppModale/appstore.fr_ALL.svg');
    },
  },
});
</script>

<style scoped>
.global-container {
  display: flex;
}
.left-container {
  display: flex;
  margin-top: 20px;
}
.right-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.container {
  display: flex;
  background-color: var(--white);
  font-weight: 500;
  font-size: var(--font-size-low-medium);
  color: var(--color-principal);
  gap: 1vw;
}
.text {
  text-align: left;
}
.img-container {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}
.store {
  display: flex;
}
.phone-img {
  max-width: 100%;
  height: 32vh;
}
.qrcode {
  width: 6vw;
}
.links {
  display: flex;
  align-self: center;
  max-width: 100%;
  height: 4vh;
  cursor: pointer;
}
</style>
